export default __webpack_public_path__ + "static/media/대건안드레아.2ca38089.svg";